module.exports = __webpack_public_path__ + "static/fipcbrownsafari1-4c1b58436ac19a81fcfff62ea2231090.jpeg";